/* Page to display the links to find Posts 
   by Department */
import React, { useEffect, useState } from "react";
import { axiosInstance, axiosReq } from "../../api/axiosDefaults";
import { Button, Card, Container } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {
  useSetCategoryContext,
  useSetDeptContext,
} from "../../contexts/DeptCategoryContext";
import sceneblue6 from "../../assets/sceneblue6.png";
import sceneblue8 from "../../assets/sceneblue8.png"; 
import newpur from "../../assets/newpur.jpg"
import silver from "../../assets/silver.jpg"
import newpur9 from "../../assets/newpur9.jpg";
import TopBox from "../../components/TopBox";
import { useCurrentUser } from "../../contexts/CurrentUserContext";

import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config";
import useHostName from "../../hooks/useHostName";
import styles from "../../styles/Scene.module.css";
import btnStyles from "../../styles/Button.module.css";
import Info from "./Info"

const Departments = () => {
  // useRedirect();
  const host = useHostName();
  const setDept = useSetDeptContext();
  const setCategory = useSetCategoryContext();
  const [postsAll, setPostsAll] = useState({ results: [] }); 
  const [showInfo, setShowInfo] = useState(false);
  const posts = postsAll.results;
  console.log(posts);

  const history = useHistory();
  const currentUser = useCurrentUser();

  const queryString = window.location.search;
  // Television
  const projectType =
    currentUser?.project_category_type &&
    JSON.parse(currentUser.project_category_type);

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  const epi = params.get("episode");
  const project = params.get("project");
  const episodeTitle = params.get("episodeTitle");

  useEffect(() => {
      /* Fetch  Posts */
      const handleMount = async () => {
        try {
          if (host === CLIENT_PROGRAM_HOSTNAME) {
            const { data } = await axiosReq(`/posts`);
            setPostsAll(data);
            console.log(data)
          } else {
            const { data } = await axiosInstance(
              `${localStorage.getItem("projectSlug")}/posts/?${
                epi ? `episode_id=${epi}` : ""
              }`,
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
                withCredentials: true,
              }
            );
            setPostsAll(data);
          }
        } catch (err) {
          console.log(err);
        }
      };
      handleMount();
  
    }, [epi]);

  /* Functions to get each departments category total posts  */
 
    // CAMERA
    const camReqUnopen = posts.filter(post => post.departments === "camera" 
      && post.category === "requirements" && post.opened_id === null).length;

    const camWorkUnopen = posts.filter(post => post.departments === "camera" 
      && post.category === "workspace" && post.opened_id === null).length;

    const camFinUnopen = posts.filter(post => post.departments === "camera" 
      && post.category === "finals" && post.opened_id === null).length;

    const camReqOpen = posts.filter(post => post.departments === "camera" 
      && post.category === "requirements" && post.opened_id).length;

    const camWorkOpen = posts.filter(post => post.departments === "camera" 
      && post.category === "workspace" && post.opened_id).length;

    const camFinOpen = posts.filter(post => post.departments === "camera" 
      && post.category === "finals" && post.opened_id).length;

    // SOUND
    const souReqUnopen = posts.filter(post => post.departments === "sound" 
      && post.category === "requirements" && post.opened_id === null).length;

    const souWorkUnopen = posts.filter(post => post.departments === "sound" 
      && post.category === "workspace" && post.opened_id === null).length;

    const souFinUnopen = posts.filter(post => post.departments === "sound" 
      && post.category === "finals" && post.opened_id === null).length;

    const souReqOpen = posts.filter(post => post.departments === "sound" 
      && post.category === "requirements" && post.opened_id).length;

    const souWorkOpen = posts.filter(post => post.departments === "sound" 
      && post.category === "workspace" && post.opened_id).length;

    const souFinOpen = posts.filter(post => post.departments === "sound" 
      && post.category === "finals" && post.opened_id).length;

    // LOCATION
    const locReqUnopen = posts.filter(post => post.departments === "location" 
      && post.category === "requirements" && post.opened_id === null).length;

    const locWorkUnopen = posts.filter(post => post.departments === "location" 
      && post.category === "workspace" && post.opened_id === null).length;

    const locFinUnopen = posts.filter(post => post.departments === "location" 
      && post.category === "finals" && post.opened_id === null).length;

    const locReqOpen = posts.filter(post => post.departments === "location" 
      && post.category === "requirements" && post.opened_id).length;

    const locWorkOpen = posts.filter(post => post.departments === "location" 
      && post.category === "workspace" && post.opened_id).length;

    const locFinOpen = posts.filter(post => post.departments === "location" 
      && post.category === "finals" && post.opened_id).length;

      // SCRIPT
      const scrReqUnopen = posts.filter(post => post.departments === "script" 
        && post.category === "requirements" && post.opened_id === null).length;

      const scrWorkUnopen = posts.filter(post => post.departments === "script" 
        && post.category === "workspace" && post.opened_id === null).length;

      const scrFinUnopen = posts.filter(post => post.departments === "script" 
        && post.category === "finals" && post.opened_id === null).length;

      const scrReqOpen = posts.filter(post => post.departments === "script" 
        && post.category === "requirements" && post.opened_id).length;

      const scrWorkOpen = posts.filter(post => post.departments === "script" 
        && post.category === "workspace" && post.opened_id).length;

      const scrFinOpen = posts.filter(post => post.departments === "script" 
        && post.category === "finals" && post.opened_id).length;

      // ART
      const artReqUnopen = posts.filter(post => post.departments === "art" 
        && post.category === "requirements" && post.opened_id === null).length;

      const artWorkUnopen = posts.filter(post => post.departments === "art" 
        && post.category === "workspace" && post.opened_id === null).length;

      const artFinUnopen = posts.filter(post => post.departments === "art" 
        && post.category === "finals" && post.opened_id === null).length;

      const artReqOpen = posts.filter(post => post.departments === "art" 
        && post.category === "requirements" && post.opened_id).length;

      const artWorkOpen = posts.filter(post => post.departments === "art" 
        && post.category === "workspace" && post.opened_id).length;

      const artFinOpen = posts.filter(post => post.departments === "art" 
        && post.category === "finals" && post.opened_id).length;

      // makeup
      const makReqUnopen = posts.filter(post => post.departments === "make-up" 
        && post.category === "requirements" && post.opened_id === null).length;

      const makWorkUnopen = posts.filter(post => post.departments === "make-up" 
        && post.category === "workspace" && post.opened_id === null).length;

      const makFinUnopen = posts.filter(post => post.departments === "make-up" 
        && post.category === "finals" && post.opened_id === null).length;

      const makReqOpen = posts.filter(post => post.departments === "make-up" 
        && post.category === "requirements" && post.opened_id).length;

      const makWorkOpen = posts.filter(post => post.departments === "make-up" 
        && post.category === "workspace" && post.opened_id).length;

      const makFinOpen = posts.filter(post => post.departments === "make-up" 
        && post.category === "finals" && post.opened_id).length;

      // COSTUME
      const warReqUnopen = posts.filter(post => post.departments === "wardrobe" 
        && post.category === "requirements" && post.opened_id === null).length;

      const warWorkUnopen = posts.filter(post => post.departments === "wardrobe" 
        && post.category === "workspace" && post.opened_id === null).length;

      const warFinUnopen = posts.filter(post => post.departments === "wardrobe" 
        && post.category === "finals" && post.opened_id === null).length;

      const warReqOpen = posts.filter(post => post.departments === "wardrobe" 
        && post.category === "requirements" && post.opened_id).length;

      const warWorkOpen = posts.filter(post => post.departments === "wardrobe" 
        && post.category === "workspace" && post.opened_id).length;

      const warFinOpen = posts.filter(post => post.departments === "wardrobe" 
        && post.category === "finals" && post.opened_id).length;

      // CASTING
      const casReqUnopen = posts.filter(post => post.departments === "casting" 
        && post.category === "requirements" && post.opened_id === null).length;

      const casWorkUnopen = posts.filter(post => post.departments === "casting" 
        && post.category === "workspace" && post.opened_id === null).length;

      const casFinUnopen = posts.filter(post => post.departments === "casting" 
        && post.category === "finals" && post.opened_id === null).length;

      const casReqOpen = posts.filter(post => post.departments === "casting" 
        && post.category === "requirements" && post.opened_id).length;

      const casWorkOpen = posts.filter(post => post.departments === "casting" 
        && post.category === "workspace" && post.opened_id).length;

      const casFinOpen = posts.filter(post => post.departments === "casting" 
        && post.category === "finals" && post.opened_id).length;

      // CASTING
      const posReqUnopen = posts.filter(post => post.departments === "post" 
        && post.category === "requirements" && post.opened_id === null).length;

      const posWorkUnopen = posts.filter(post => post.departments === "post" 
        && post.category === "workspace" && post.opened_id === null).length;

      const posFinUnopen = posts.filter(post => post.departments === "post" 
        && post.category === "finals" && post.opened_id === null).length;

      const posReqOpen = posts.filter(post => post.departments === "post" 
        && post.category === "requirements" && post.opened_id).length;

      const posWorkOpen = posts.filter(post => post.departments === "post" 
        && post.category === "workspace" && post.opened_id).length;

      const posFinOpen = posts.filter(post => post.departments === "post" 
        && post.category === "finals" && post.opened_id).length;

      // PRODUCTION
      const proReqUnopen = posts.filter(post => post.departments === "production" 
        && post.category === "requirements" && post.opened_id === null).length;

      const proWorkUnopen = posts.filter(post => post.departments === "production" 
        && post.category === "workspace" && post.opened_id === null).length;

      const proFinUnopen = posts.filter(post => post.departments === "production" 
        && post.category === "finals" && post.opened_id === null).length;

      const proReqOpen = posts.filter(post => post.departments === "production" 
        && post.category === "requirements" && post.opened_id).length;

      const proWorkOpen = posts.filter(post => post.departments === "production" 
        && post.category === "workspace" && post.opened_id).length;

      const proFinOpen = posts.filter(post => post.departments === "production" 
        && post.category === "finals" && post.opened_id).length;

      // STUNTS
      const stuReqUnopen = posts.filter(post => post.departments === "stunts" 
        && post.category === "requirements" && post.opened_id === null).length;

      const stuWorkUnopen = posts.filter(post => post.departments === "stunts" 
        && post.category === "workspace" && post.opened_id === null).length;

      const stuFinUnopen = posts.filter(post => post.departments === "stunts" 
        && post.category === "finals" && post.opened_id === null).length;

      const stuReqOpen = posts.filter(post => post.departments === "stunts" 
        && post.category === "requirements" && post.opened_id).length;

      const stuWorkOpen = posts.filter(post => post.departments === "stunts" 
        && post.category === "workspace" && post.opened_id).length;

      const stuFinOpen = posts.filter(post => post.departments === "stunts" 
        && post.category === "finals" && post.opened_id).length;

      // ELECTRIC
      const eleReqUnopen = posts.filter(post => post.departments === "electric" 
        && post.category === "requirements" && post.opened_id === null).length;

      const eleWorkUnopen = posts.filter(post => post.departments === "electric" 
        && post.category === "workspace" && post.opened_id === null).length;

      const eleFinUnopen = posts.filter(post => post.departments === "electric" 
        && post.category === "finals" && post.opened_id === null).length;

      const eleReqOpen = posts.filter(post => post.departments === "electric" 
        && post.category === "requirements" && post.opened_id).length;

      const eleWorkOpen = posts.filter(post => post.departments === "electric" 
        && post.category === "workspace" && post.opened_id).length;

      const eleFinOpen = posts.filter(post => post.departments === "electric" 
        && post.category === "finals" && post.opened_id).length;

      // UNIVERSAL
      const uniReqUnopen = posts.filter(post => post.departments === "universal" 
        && post.category === "requirements" && post.opened_id === null).length;

      const uniWorkUnopen = posts.filter(post => post.departments === "universal" 
        && post.category === "workspace" && post.opened_id === null).length;

      const uniFinUnopen = posts.filter(post => post.departments === "universal" 
        && post.category === "finals" && post.opened_id === null).length;

      const uniReqOpen = posts.filter(post => post.departments === "universal" 
        && post.category === "requirements" && post.opened_id).length;

      const uniWorkOpen = posts.filter(post => post.departments === "universal" 
        && post.category === "workspace" && post.opened_id).length;

      const uniFinOpen = posts.filter(post => post.departments === "universal" 
        && post.category === "finals" && post.opened_id).length;

  /* The following 13 functions take the user to Posts
     * in a particular Department and Category
     * They set the Dept and Category Contexts 
     * This will be read on App.js page and passed
       as a filter to the /departments Route*/

      const handleClickCameraReq = () => {
        setDept("camera");
        setCategory("requirements");
        history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
      };

      const handleClickCameraWor = () => {
        setDept("camera");
        setCategory("workspace");
        history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
      };

      const handleClickCameraFin = () => {
        setDept("camera");
        setCategory("finals");
        history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );
      };

    const handleClickSoundReq = () => {
      setDept("sound");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickSoundWor = () => {
      setDept("sound");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickSoundFin = () => {
      setDept("sound");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickLocationReq = () => {
      setDept("location");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickLocationWor = () => {
      setDept("location");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickLocationFin = () => {
      setDept("location");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };
    
    const handleClickScriptReq = () => {
      setDept("script");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickScriptWor = () => {
      setDept("script");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickScriptFin = () => {
      setDept("script");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickArtReq = () => {
      setDept("art");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickArtWor = () => {
      setDept("art");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickArtFin = () => {
      setDept("art");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickMakeupReq = () => {
      setDept("make-up");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickMakeupWor = () => {
      setDept("make-up");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickMakeupFin = () => {
      setDept("make-up");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    // const handleClickMakeup = (category) => {
    //   setDept("make-up");
    //   setCategory(category);
    //   history.push(`/dept/category`);

    // };

    const handleClickWardrobeReq = () => {
      setDept("wardrobe");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickWardrobeWor = () => {
      setDept("wardrobe");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickWardrobeFin = () => {
      setDept("wardrobe");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    // const handleClickWardrobe = (category) => {
    //   setDept("wardrobe");
    //   setCategory(category);
    //   history.push(`/departments`);

    // };

    const handleClickCastingReq = () => {
      setDept("casting");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickCastingWor = () => {
      setDept("casting");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickCastingFin = () => {
      setDept("casting");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    // const handleClickCasting = (category) => {
    //   setDept("casting");
    //   setCategory(category);
    //   history.push(`/departments`);
    // }; 

    const handleClickPostReq = () => {
      setDept("post");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickPostWor = () => {
      setDept("post");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );; 
    };

    const handleClickPostFin = () => {
      setDept("post");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    // const handleClickPost = (category) => {
    //   setDept("post");
    //   setCategory(category);
    //   history.push(`/departments`);

    // };

    const handleClickProductionReq = () => {
      setDept("production");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickProductionWor = () => {
      setDept("production");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickProductionFin = () => {
      setDept("production");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    // const handleClickProduction = (category) => {
    //   setDept("production");
    //   setCategory(category);
    //   history.push(`/departments`);

    // };

    const handleClickStuntsReq = () => {
      setDept("stunts");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickStuntsWor = () => {
      setDept("stunts");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickStuntsFin = () => {
      setDept("stunts");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    // const handleClickStunts = (category) => {
    //   setDept("stunts");
    //   setCategory(category);
    //   history.push(`/departments`);
    // };

    const handleClickElectricReq = () => {
      setDept("electric");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickElectricWor = () => {
      setDept("electric");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickElectricFin = () => {
      setDept("electric");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    // const handleClickElectric = (category) => {
    //   setDept("electric");
    //   setCategory(category);
    //   history.push(`/departments`);
    // };

    const handleClickUniversalReq = () => {
      setDept("universal");
      setCategory("requirements");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    const handleClickUniversalWor = () => {
      setDept("universal");
      setCategory("workspace");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        ); 
    };

    const handleClickUniversalFin = () => {
      setDept("universal");
      setCategory("finals");
      history.push(
          `/${localStorage.getItem("projectSlug")}/departments${
            epi && project && episodeTitle
              ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
              : ""
          }`
        );  
    };

    // const handleClickUni = (category) => {
    //   setDept("universal");
    //   setCategory(category);
    //   history.push(`/departments`);
    // };

    // const handleClickSound = (category) => {
    //   setDept("sound");
    //   setCategory(category);
    //   history.push(`/departments`);

    // };

    // const handleClickLocation = (category) => {
    //   setDept("location");
    //   setCategory(category);
    //   history.push(`/departments`);

    // };

    // const handleClickScript = (category) => {
    //   setDept("script");
    //   setCategory(category);
    //   history.push(`/departments`);

    // };

    // const handleClickArt = (category) => {
    //   setDept("art");
    //   setCategory(category);
    //   history.push(`/departments`);

    // };

  // const handleClickCamera = (category) => {
  //   setDept("camera");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickSound = (category) => {
  //   setDept("sound");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickLocation = (category) => {
  //   setDept("location");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickScript = (category) => {
  //   setDept("script");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickArt = (category) => {
  //   setDept("art");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickMakeup = (category) => {
  //   setDept("make-up");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickWardrobe = (category) => {
  //   setDept("wardrobe");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickCasting = (category) => {
  //   setDept("casting");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickPost = (category) => {
  //   setDept("post");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickProduction = (category) => {
  //   setDept("production");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickStunts = (category) => {
  //   setDept("stunts");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickElectric = (category) => {
  //   setDept("electric");
  //   setCategory(category);
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // const handleClickUni = (category) => {
  //     setDept("universal");
  //     setCategory(category);
  //     history.push(`/departments`);
  //   };


  // const handleClickUniversal = () => {
  //   setDept("universal");
  //   setCategory("");
  //   history.push(
  //     `/${localStorage.getItem("projectSlug")}/departments${
  //       epi && project && episodeTitle
  //         ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
  //         : ""
  //     }`
  //   );
  // };

  // useLayoutEffect(() => {
  //   if (projectType === "Television" && !epi) {
  //     history.push(
  //       `/${localStorage.getItem(
  //         "projectSlug"
  //       )}/episodes/create?nextPage=findposts`
  //     );
  //   }
  // }, [projectType, history]);

  return (
    <div>
      <TopBox title="Quick Find Posts" episodeTitle={`Episode ${episodeTitle}`} />
      <Button
        className={`${btnStyles.Button} ${btnStyles.Blue} my-2`}
        onClick={() => history.goBack()}
      >
        Back
      </Button>
      <Button
        className={`float-right py-0 my-2 ${btnStyles.Order} ${btnStyles.Button}`}
        onClick={() => setShowInfo((showInfo) => !showInfo)}
      >
        INFO
      </Button>
      {!showInfo ? "" : <Info />}
      <h5 className={`mt-1 mb-1 py-1 ${styles.SubTitle } text-center`}>
      QUICK FIND POSTS
      </h5>
      <Container className={`my-3`}>
        <Row className="mb-4 mt-3">
          <Col className="text-center px-0" xs={4}>
            <Button
              onClick={() =>
                history.push(
                  `/${localStorage.getItem("projectSlug")}/archived${
                    epi && project && episodeTitle
                      ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
                      : ""
                  }`
                )
              }
              className={`${btnStyles.Button} py-0 px-2 ${btnStyles.Bright}`}
            >
              Starred Posts
            </Button>
          </Col>
          <Col className="text-center px-0" xs={4}>
            <Button
              onClick={() =>
                history.push(
                  `/${localStorage.getItem("projectSlug")}/all_posts${
                    epi && project && episodeTitle
                      ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
                      : ""
                  }`
                )
              }
              className={`${btnStyles.Button} py-0 px-3 ${btnStyles.Bright}`}
            >
              All Posts
            </Button>
          </Col>
          <Col className="text-center px-0" xs={4}>
            <Button
              onClick={() =>
                history.push(
                  `/${localStorage.getItem("projectSlug")}/liked${
                    epi && project && episodeTitle
                      ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
                      : ""
                  }`
                )
              }
              className={`${btnStyles.Button} py-0 px-3 ${btnStyles.Bright}`}
            >
              Liked Posts
            </Button>
          </Col>
        </Row>
        <Row className="mt-1">
          <Col className="text-center">
            <Button
              onClick={() =>
                history.push(
                  `/${localStorage.getItem("projectSlug")}/feeds${
                    epi && project && episodeTitle
                      ? `?episode=${epi}&project=${project}&episodeTitle=${episodeTitle}`
                      : ""
                  }`
                )
              }
              className={`${btnStyles.Button} ${btnStyles.Wide2} ${btnStyles.Bright}`}
            >
              Feed
            </Button>
          </Col>
        </Row>
      </Container>
      <Row>
        <Col md={{span: 8, offset: 2}} className={`text-center`}>
         <hr/>
        </Col>
        </Row>
      {/* Departments */}
      <div className='mt-4'>
        <Row>
        <Col className={`text-center`}>
         <h5 className={`${styles.BoldScene } mb-3`}>
          POSTS BY DEPARTMENT
         </h5>
        </Col>
        </Row>
        {/* Universal */}
        <Row className={`mt-1`} >
            <Col xs={2} md={4}  ></Col>
            <Col className='px-1 px-md-2' xs={8} md={4} >
            <div className={` ${styles.CardBoxIm} py-2 px-2`}
              style={{
                background: `url(${sceneblue8})`
              }}
              >
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              UNIVERSAL
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-2 pl-md-3 pl-lg-5`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-2 pr-md-3 pr-lg-5`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickUniversalReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{uniReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{uniReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickUniversalWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{uniWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{uniWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickUniversalFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{uniFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{uniFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
            </Col>
        </Row>
        {/* Camera Sound ... */}
        <Row className='px-2'>
        {/* CAMERA 1*/}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              style={{background: `url(${newpur9})`,}}
              // style={{background: `url(${silver})`,}}
              >
              <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              CAMERA
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq}`} 
              onClick={() => handleClickCameraReq() }>
              <Row className='py-0 mt-1'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{camReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{camReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickCameraWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{camWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{camWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickCameraFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{camFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{camFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* SOUND 2 */}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              style={{background: `url(${sceneblue6})`,}}
              >
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              SOUND
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickSoundReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{souReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{souReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickSoundWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{souWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{souWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickSoundFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{souFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className='d-block d-md-none'> FINALS</p>
              <p className='d-none d-md-block'> FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{souFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* LOCATION 3*/}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              style={{
                background: `url(${sceneblue6})`,
              }}
              >
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              LOCATION
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickLocationReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{locReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{locReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickLocationWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{locWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{locWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickLocationFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{locFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className='d-block d-md-none'> FINALS</p>
              <p className='d-none d-md-block'> FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{locFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* SCRIPT 4*/}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              style={{
                background: `url(${sceneblue6})`,
              }}
              >
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              SCRIPT
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickScriptReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{scrReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{scrReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickScriptWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{scrWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{scrWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickScriptFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{scrFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className='d-block d-md-none'> FINALS</p>
              <p className='d-none d-md-block'> FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{scrFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* ART 5*/}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              style={{
                background: `url(${sceneblue6})`,
              }}
              >
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              ART
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickArtReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{artReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{artReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickArtWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{artWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{artWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickArtFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{artFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className='d-block d-md-none'> FINALS</p>
              <p className='d-none d-md-block'> FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{artFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* MAKEUP 6 */}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              style={{background: `url(${newpur})`,}}
              >
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              MAKEUP
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickMakeupReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{makReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{makReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickMakeupWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{makWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{makWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickMakeupFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{makFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{makFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* WARDROBE 7 */}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              style={{
                background: `url(${sceneblue6})`,
              }}
              >
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              WARDROBE
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickWardrobeReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{warReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{warReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickWardrobeWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{warWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{warWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickWardrobeFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{warFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{warFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* casting 8 */}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              style={{background: `url(${sceneblue6})`,}}>
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              CASTING
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickCastingReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{casReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{casReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickCastingWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{casWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{casWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickCastingFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{casFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{casFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* POST/VFX 9 */}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              style={{background: `url(${newpur})`,}}
              >
              <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              POST/VFX
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickPostReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{posReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{posReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickPostWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{posWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{posWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickPostFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{posFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{posFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* PRODUCTION 10 */}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              style={{
                background: `url(${sceneblue6})`,
              }}
              >
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              PRODUCTION
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickProductionReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{proReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{proReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickProductionWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{proWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{proWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickProductionFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{proFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{proFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* STUNTS 11*/}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              // style={{background: `url(${silver})`,}}
              style={{background: `url(${newpur9})`,}}
              >
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              STUNTS/SFX
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickStuntsReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{stuReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{stuReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickStuntsWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{stuWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{stuWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickStuntsFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{stuFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{stuFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        {/* ELECTRIC 12 */}
        <Col className='px-2 px-md-2' xs={6} sm={4} md={3} lg={2} >
              <div className={` ${styles.CardBox2} px-2`}
              // style={{background: `url(${newpur9})`,}}
              style={{background: `url(${sceneblue6})`,}}
              >
                <Row className='my-2'>
              <Col>
              <h5 className={`text-center ${styles.White2} mt-2`} >
              ELECTRIC/GRIP
              </h5>
              </Col>
              </Row>
              {/* read */}
              <Row>
                <Col xs={6}>
                <p className={`${styles.WhiteText} pl-1`}>READ</p></Col>
                <Col xs={6} >
                <p className={`${styles.WhiteText} float-right pr-1`}>UNREAD</p></Col>
              </Row>
              {/* requirements */}
              <div className={` ${styles.WhiteReq} mt-1`} 
              onClick={() => handleClickElectricReq() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{eleReqOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p className={`${styles.WhiteReq1} d-none d-sm-block`}> REQUIREMENTS</p>
              <p className={`${styles.WhiteReq1} d-block d-sm-none`}> REQUIREM.</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`${styles.Read} float-left`}>{eleReqUnopen}</p></Col>
              </Row>
              </div>
              {/* workspace */}
              <div className={` ${styles.WhiteReq} mt-3`}
              onClick={() => handleClickElectricWor() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{eleWorkOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > WORKSPACE</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{eleWorkUnopen}</p></Col>
              </Row>
              </div>
              {/* Finals */}
              <div className={` ${styles.WhiteReq} my-3`}
              onClick={() => handleClickElectricFin() }>
              <Row className='py-0'>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-right ${styles.Read}`}>{eleFinOpen}</p></Col>
              <Col xs={8} className={`text-center`}>
              <p > FINALS</p>
              </Col>
              <Col xs={2} className={`text-center px-0`}>
              <p className={`float-left ${styles.Read}`}>{eleFinUnopen}</p></Col>
              </Row>
              </div>
              </div>
        </Col>
        </Row>
      </div>
    </div>
  );
};

export default Departments;
